import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StepperFormInt from "../src/Components/DigitalResume/StepperForm/StepperForm";
import "./App.css";
import ForgotPassword from "./Components/Auth/ForgotPassword/ForgotPassword";
import Login from "./Components/Auth/Login/Login";
import OtpScreen from "./Components/Auth/OtpScreen/OtpScreen";
import Avatar from "./Components/Avatar/Avatar";
import AvatarSelectionForm from "./Components/Avatar/AvatarSelectionForm";
import CreateUser from "./Components/Createuser/Createuser";
import DealerShipDashBoard from "./Components/DealerShipDashBoard/DealerShipDashBoard";
import AddDealershipForm from "./Components/DealershipForm/AddDealershipForm";
import Header from "./Components/Header/Header";
import AddProduct from "./Components/Products/AddProduct";
import ProfileCard from "./Components/ProfileCard/ProfileCard";
import SideBar from "./Components/SideBar/SideBar";
import SubscriptionPlans from "./Components/SubscriptionPlans/SubscriptionPlans";
import UsersTable from "./Components/UsersTable/UsersTable";
import DynamicForm from "./Components/DynamicForm/DynamicForm";
import StepperForm from "./Components/StepperForm/StepperForm";
import Home from "./Components/Home/Home";
import NewLandingPage from "./Components/Home/newLandingpage";
import AIAgentsPage from "./Components/Home/AIAgentsPage";
import PlatformPage from "./Components/Home/PlatformPage";
import SalesOperationsPage from "./Components/Home/SalesOperationsPage";
import SolutionsPage from "./Components/Home/SolutionsPage";
import PricingPage from "./Components/Home/PricingPage";
import ContactPage from "./Components/Home/ContactPage";
import AdminDashboard from "./Components/AdminDashboard/AdminDashboard";
import DealsTable from "./Components/DealerShipDashBoard/DealsTable";
import ResumeAvatar from "./Components/DigitalResume/PitchAimee/Avatar";
import AvatarBoard from "./Components/f&i_Product/Avatar";
import TestBoard from "./Components/f&i_Product/TestBoard";
import Cars from "./Components/Car";
import CustomerManagement from "./Components/Customer";
import Deals from "./Components/Deals";
import DemoDataPage from "./Components/Demo/DemoDataPage";
import DemoRequests from "./Components/Admin/DemoRequests/DemoRequests";
import InDealership from "./Components/Int-DealershipForm/AddDealershipForm";
import { ThemeProvider } from "./Components/BrandColors/Context/ThemeContext";
import { Toaster } from "react-hot-toast";

import ChatWidget from "./Components/ChatBotWidget/ChatWidget";
import ChatbotCustomizer from "./Components/ChatBotWidget/ChatbotCustomizer";
import ApiKeysSettings from "./Components/ChatBotWidget/ApiKeysSettings";
import CampaignsDashboard from "./Components/Campaigns/CampaignsDashboard";
import { getBackendBaseUrl } from "./utils/apiUrl";

const ProtectedRoute = ({ children, isAuthenticated }) => {
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const RedirectIfAuthenticated = ({ children, isAuthenticated }) => {
  return isAuthenticated ? <Navigate to="/" replace /> : <>{children}</>;
};

const App = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  console.log("isAuntenticate = > ", isAuthenticated);

  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user"));

  const queryParams = new URLSearchParams(window.location.search);
  const isWidget = queryParams.get("widget") === "true";
  const agentId = queryParams.get("agentId");

  const [widgetAgent, setWidgetAgent] = useState(null);
  const [loadingWidget, setLoadingWidget] = useState(isWidget);

  useEffect(() => {
    if (isWidget) {
      const fetchAgent = async () => {
        try {
          const baseUrl = getBackendBaseUrl();
          const res = await fetch(`${baseUrl}/chatbot/agents/${agentId || "default"}`);
          if (res.ok) {
            const data = await res.json();
            if (data.success && data.data) {
              setWidgetAgent(data.data);
            }
          }
        } catch (err) {
          console.error("Error fetching widget agent config:", err);
        } finally {
          setLoadingWidget(false);
        }
      };
      fetchAgent();
    }
  }, [isWidget, agentId]);

  // Public chatbot widget — only shown on non-authenticated public pages
  const [publicChatbotConfig, setPublicChatbotConfig] = useState(null);
  const location = typeof window !== 'undefined' ? window.location.pathname : '/';
  const protectedPaths = [
    '/dashboard', '/chatbot-customizer', '/overview-chatbot', '/agent-lab', '/api-keys', '/user-management',
    '/avatar-selection', '/avatar-playground', '/subscriptions', '/dealership',
    '/pitch-dealership', '/pitch-aimee', '/testboard', '/products', '/profile',
    '/step', '/deals-table', '/f&i-service', '/createuser', '/deals', '/cars',
    '/customer', '/board', '/pitch-aimee-board', '/demo', '/campaigns'
  ];
  const isProtectedPath = protectedPaths.some(p => location === p || location.startsWith(p + '/'));
  const showPublicChatbot = !isAuthenticated && !isWidget && !isProtectedPath;

  useEffect(() => {
    if (showPublicChatbot) {
      const fetchPrimaryAgent = async () => {
        try {
          const baseUrl = getBackendBaseUrl();
          // Try primary endpoint first, fall back to default agent
          let res = await fetch(`${baseUrl}/chatbot/agents/primary`);
          if (!res.ok) {
            res = await fetch(`${baseUrl}/chatbot/agents/default`);
          }
          if (res.ok) {
            const data = await res.json();
            if (data.success && data.data) {
              setPublicChatbotConfig(data.data);
              return;
            }
          }
        } catch (err) {
          console.warn('Failed to fetch primary chatbot config:', err);
        }
        // Fallback: use a minimal default config so widget still renders
        setPublicChatbotConfig({
          id: 'primary',
          name: 'Ava',
          logo: '💬',
          position: 'right',
          offsetX: 14,
          offsetY: 14
        });
      };
      fetchPrimaryAgent();
    }
  }, [showPublicChatbot]);

  if (isWidget) {
    if (loadingWidget) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#0b0f1e', color: '#fff' }}>
          Loading Chatbot...
        </div>
      );
    }
    const config = widgetAgent || {};
    return (
      <div style={{ width: "100vw", height: "100vh", position: "relative", overflow: "hidden" }}>
        <ChatWidget
          agentId={agentId || config.id || "default"}
          embeddedMode={true}
          primaryColor={config.primaryColor}
          agentName={config.name || config.agentName}
          customGreeting={config.customGreeting}
          systemPrompt={config.systemPrompt}
          conversationalContext={config.conversationalContext}
          logo={config.logo}
          position={config.position}
          replicaId={config.replicaId}
          documentIds={config.documentIds || []}
          videoHeight={config.videoHeight}
          offsetX={config.offsetX}
          offsetY={config.offsetY}
          bodyBgColor={config.bodyBgColor}
          headerBgColor={config.headerBgColor}
          headerTextColor={config.headerTextColor}
          inputBgColor={config.inputBgColor}
          textColor={config.textColor}
          widgetHeight={config.widgetHeight}
          widgetWidth={config.widgetWidth}
          verticalAlign={config.verticalAlign}
          applyGreenscreen={config.applyGreenscreen}
          avatarBackground={config.avatarBackground}
          composingText={config.composingText}
          connectingText={config.connectingText}
          placeholderText={config.placeholderText}
          joiningText={config.joiningText}
          avatarBackgroundSize={config.avatarBackgroundSize}
          avatarZoom={config.avatarZoom}
          avatarTranslateX={config.avatarTranslateX}
          avatarTranslateY={config.avatarTranslateY}
          showAvatarPreview={config.showAvatarPreview}
        />
      </div>
    );
  }

  return (
    <ThemeProvider>
      <ToastContainer position="top-right" autoClose={2000} />
      <Router>
        <div className={`App ${isOpen ? "shifted" : ""}`}>
          <Routes>
            <Route path="/dy" element={<DynamicForm />} />
            <Route
              path="/login"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <Login />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/forgotPassword"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <ForgotPassword />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/reset-password"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <ForgotPassword />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/otp"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <OtpScreen />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/dy"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <DynamicForm />
                </RedirectIfAuthenticated>
              }
            />

            <Route
              path="/"
              element={
                isAuthenticated ? (
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <div className="main-layout">
                      <SideBar
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        sidebarRef={sidebarRef}
                      />
                      <div
                        className={
                          isOpen ? "protected-content" : "protected-content isClose"
                        }
                      >
                        <Header />
                        {user?.role === "Owner" ? (
                          <AdminDashboard />
                        ) : (
                          <DealerShipDashBoard />
                        )}
                      </div>
                    </div>
                  </ProtectedRoute>
                ) : (
                  <NewLandingPage />
                )
              }
            />

            <Route
              path="/f&i-service"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <StepperForm />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/createuser"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <CreateUser />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/deals"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <Deals />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cars"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <Cars />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <CustomerManagement />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/campaigns"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <CampaignsDashboard />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/chatbot-customizer"
              element={<Navigate to="/agent-lab" replace />}
            />
            <Route
              path="/overview-chatbot"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      style={{ flex: 1, display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden", marginLeft: isOpen ? "16rem" : "5rem", transition: "margin-left 0.3s ease-in-out" }}
                    >
                      <Header />
                      <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                        <ChatbotCustomizer mode="overview" />
                      </div>
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent-lab"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      style={{ flex: 1, display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden", marginLeft: isOpen ? "16rem" : "5rem", transition: "margin-left 0.3s ease-in-out" }}
                    >
                      <Header />
                      <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                        <ChatbotCustomizer mode="agents" />
                      </div>
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/api-keys"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <ApiKeysSettings />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-management"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <UsersTable />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/avatar-selection"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <AvatarSelectionForm />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/avatar-playground"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <Avatar />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscriptions"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <SubscriptionPlans />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dealership"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <AddDealershipForm />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pitch-dealership"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <InDealership />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pitch-aimee"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <StepperFormInt />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/testboard"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <TestBoard />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <AddProduct />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <ProfileCard />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <DealerShipDashBoard />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/demo"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <DemoDataPage />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/demo-requests"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <DemoRequests />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/step"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <StepperForm />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/deals-table"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <DealsTable />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />

            {/* Non-Protected Routes */}
            <Route path="/board" element={<AvatarBoard />} />
            <Route path="/pitch-aimee-board" element={<ResumeAvatar />} />
            <Route path="/newlanding" element={<NewLandingPage />} />
            <Route path="/new-landing" element={<NewLandingPage />} />
            <Route path="/ai-agents" element={<AIAgentsPage />} />
            <Route path="/platform" element={<PlatformPage />} />
            <Route path="/sales-operations" element={<SalesOperationsPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </div>
      </Router>
      {/* Public Chatbot — floats fixed on public pages only, never on internal pages */}
      {showPublicChatbot && publicChatbotConfig && (
        <ChatWidget
          key={publicChatbotConfig.id}
          agentId={publicChatbotConfig.id || "default"}
          embeddedMode={false}
          primaryColor={publicChatbotConfig.primaryColor}
          agentName={publicChatbotConfig.name || publicChatbotConfig.agentName}
          customGreeting={publicChatbotConfig.customGreeting}
          systemPrompt={publicChatbotConfig.systemPrompt}
          conversationalContext={publicChatbotConfig.conversationalContext}
          logo={publicChatbotConfig.logo}
          position={publicChatbotConfig.position || "right"}
          replicaId={publicChatbotConfig.replicaId}
          documentIds={publicChatbotConfig.documentIds || []}
          videoHeight={publicChatbotConfig.videoHeight}
          offsetX={publicChatbotConfig.offsetX ?? 14}
          offsetY={publicChatbotConfig.offsetY ?? 14}
          bodyBgColor={publicChatbotConfig.bodyBgColor}
          headerBgColor={publicChatbotConfig.headerBgColor}
          headerTextColor={publicChatbotConfig.headerTextColor}
          inputBgColor={publicChatbotConfig.inputBgColor}
          textColor={publicChatbotConfig.textColor}
          minimizedText={publicChatbotConfig.minimizedText}
          minimizedBgColor={publicChatbotConfig.minimizedBgColor}
          minimizedTextColor={publicChatbotConfig.minimizedTextColor}
          widgetHeight={publicChatbotConfig.widgetHeight}
          widgetWidth={publicChatbotConfig.widgetWidth}
          verticalAlign={publicChatbotConfig.verticalAlign}
          logoBgColor={publicChatbotConfig.logoBgColor}
          thumbnailVideoUrl={publicChatbotConfig.thumbnailVideoUrl}
          voiceButtonText={publicChatbotConfig.voiceButtonText}
          applyGreenscreen={publicChatbotConfig.applyGreenscreen}
          avatarBackground={publicChatbotConfig.avatarBackground}
          composingText={publicChatbotConfig.composingText}
          connectingText={publicChatbotConfig.connectingText}
          placeholderText={publicChatbotConfig.placeholderText}
          joiningText={publicChatbotConfig.joiningText}
          avatarBackgroundSize={publicChatbotConfig.avatarBackgroundSize}
          avatarZoom={publicChatbotConfig.avatarZoom}
          avatarTranslateX={publicChatbotConfig.avatarTranslateX}
          avatarTranslateY={publicChatbotConfig.avatarTranslateY}
          showAvatarPreview={publicChatbotConfig.showAvatarPreview}
        />
      )}
      <Toaster position="top-right" />
    </ThemeProvider>
  );
};

export default App;
